module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "leftbar-view elffy-dashboard",
    class: {
      'left-aside-toggle': _vm.toggle_aside
    }
  }, [_vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "main-container"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "widget-wrap"
  }, [_c('div', {
    staticClass: "widget-header block-header margin-bottom-0 clearfix"
  }, [_c('div', {
    staticClass: "pull-left"
  }, [_c('h3', [_vm._v("你參與的專案")])])]), _vm._v(" "), _c('div', {
    staticClass: "widget-container"
  })]), _vm._v(" "), _c('div', {
    staticClass: "widget-wrap"
  }, [_c('div', {
    staticClass: "widget-header block-header margin-bottom-0 clearfix"
  }, [_c('div', {
    staticClass: "pull-left"
  }, [_c('h3', [_vm._v("進行中的專案")])])]), _vm._v(" "), _c('div', {
    staticClass: "widget-container"
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2f546d3e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProjectManage/ProjectsListBoard.vue
// module id = 680
// module chunks = 4